/**
 * Utility functions for formatting data
 */

export const formatDuration = (seconds: number): string => {
  if (!seconds || seconds < 0) return '0s';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  if (minutes > 0) {
    return `${minutes}m`;
  }

  return `${secs}s`;
};

export const formatTime = (seconds: number): string => {
  if (!seconds || seconds < 0) return '0:00';

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const formatPart = (num: number): string => String(num).padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${formatPart(minutes)}:${formatPart(secs)}`;
  }

  return `${minutes}:${formatPart(secs)}`;
};
